/** @jsx jsx */

import React, {
  Fragment as _,
  useLayoutEffect,
  useEffect,
  useRef,
  useContext,
  useState,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';
import isIE from 'services/isIE';
import onScrollEnds from 'services/onScrollEnds';
import hexToRgb from 'services/hexToRGB';
import { rgbaFromHexAndOpacity } from 'services/rgbaFromHexAndOpacity';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

export const sortationPanelDefaultStyling = {
  panelBackgroundDragging: '#949595',
};

const Option = ({ option, isDragging }) => {
  const { id, children } = option;

  const context = useContext<any>(interactionContext);

  const optionContainer = useRef<any>(null);

  const { includeImage } = context.props;

  const {
    panelBackground: _panelBackground = includeImage ? '#fff' : lGrey0,
    panelBackgroundDragging: _panelBackgroundDragging = sortationPanelDefaultStyling.panelBackgroundDragging,
    textColor = includeImage ? '#000' : '#fff',
    textColorDragging = '#000',
    optionBorderRadius = 5,
    optionBackgroundOpacity = includeImage ? 0 : 100,
    optionBackgroundOpacityDragging: _optionBackgroundOpacityDragging = 100,
    optionOutline = false,
    optionOutlineColor = '',
    includeText = true,
    imagePosition = 'top',
  } = context.props;

  const [txt, img] = children;

  const panelBackground = rgbaFromHexAndOpacity(
    _panelBackground,
    optionBackgroundOpacity
  );

  const panelTextColor = context.props.panelTextColor || textColor || '#fff'; // doubleTap the default
  const panelTextColorDragging =
    context.props.panelTextColorDragging || textColorDragging || '#000'; // doubleTap the default

  const { r: rr, g: gg, b: bb } = hexToRgb(_panelBackgroundDragging);
  const optionBackgroundOpacityDragging =
    _optionBackgroundOpacityDragging * 0.01;
  const panelBackgroundDragging = `rgba(${rr}, ${gg}, ${bb}, 1)`; // ${optionBackgroundOpacityDragging}

  useLayoutEffect(() => {
    // remove the chameleon-text class
    // so only responds to local color
    const chameleonText = optionContainer.current.querySelector(
      '.chameleon-text'
    );
    chameleonText && chameleonText.classList.remove('chameleon-text');
  });

  useEffect(() => {
    if (!isIE() || !optionContainer.current) {
      return;
    }
    //
    let tick;

    const onResize = () => {
      const content = optionContainer.current.firstElementChild;

      clearInterval(tick);

      tick = setInterval(() => {
        if (content.scrollHeight === 0) {
          return;
        }

        if (
          optionContainer.current.scrollHeight ===
          content.scrollHeight + 10
        ) {
          clearInterval(tick);
        }

        optionContainer.current.style.height = `${content.scrollHeight + 10}px`;
      }, 1000 / 60);
    };

    onScrollEnds(onResize);
    addEventListener('resize', onResize);

    onResize();

    return () => {
      removeEventListener('resize', onResize);
    };
  }, []);

  let flexDirection = {
    top: 'column',
    bottom: 'column-reverse',
    left: 'row',
    right: 'row-reverse',
  }[imagePosition];

  const columnWidth =
    includeImage && includeText && ['left', 'right'].includes(imagePosition)
      ? '50%'
      : '100%';

  return (
    <div
      ref={optionContainer}
      id={`sortation-option-${id}`}
      className="sortation-option"
      css={css({
        display: 'flex',
        alignItems: 'center',

        ...(includeImage && {
          flexDirection,
        }),

        minHeight: 55,
        background: isDragging ? panelBackgroundDragging : panelBackground,
        margin: '5px 0',
        padding: optionBackgroundOpacity === 0 ? 0 : '5px 10px',
        //

        border: `1px solid ${
          optionOutline && optionOutlineColor
            ? optionOutlineColor
            : 'transparent'
        }`,

        borderRadius: optionBorderRadius,

        [`* ${!isDragging ? ':not(span)' : ''}`]: {
          color: isDragging
            ? `${panelTextColorDragging} !important`
            : panelTextColor,
        },

        'h1, h2, h3, p': {
          margin: 0,
        },

        '[class*="ReadOnlyText"]': {
          width: '100%',
        },

        ...(!window.dev() && {
          userSelect: 'none',
        }),

        '[class*="ReadOnlyText"]': {
          width: '100%',
        },
      })}
    >
      {!!includeImage && (
        <div
          style={{
            flex: 1,
          }}
        >
          {img}
        </div>
      )}

      {!!!includeImage && txt}
    </div>
  );
};

export default Option;
